import { IonCol, IonPage, IonRow } from "@ionic/react";
import { Anywhere, PCmiler } from "../../../utils/constants";
import { ManageCapacityHeader } from "../../../web/components/manage-capacity/ManageCapacityHeader";
import ToggleButton from "../../../web/components/toggle-button/ToggleButton";
import React, { useEffect, useState } from "react";
import { ManageCapacityCard } from "./ManageCapacityCard";
import "./ManageCapacitySeeResults.scss";
import { LoadsList } from "../../../web/components/loads-list";
import { ShipmentMap } from "../../../web/components/pcmiler-map";
import SortingOptions from "../../../components/core/SortOptions/SortingOptions";
import { getSortOptions } from "../../../utils/SortOptions/SortOptions";
import ShowLoadCountBtn from "../../../web/components/ShowLoadCountBtn/ShowLoadCountBtn";
import { GoogleShipmentMap } from "../../../web/components/google-map";
import { IONICWrapper } from "../../../utils/common";

export const ManageCapacitySeeResultPage: React.FunctionComponent<any> = (
  props: any
) => {
  const {
    capacityLoadLoadPostings,
    totalRecords,
    currentPage,
    pageSize,
    shouldShowLoadMoreUpdate
  } = props;
  const [showMap, setShowMap] = useState<boolean>(false);
  const [loads, setLoads] = useState<any>(capacityLoadLoadPostings);
  const [usePCmilerMaps, setPCmilerMaps] = useState<boolean>(false);
  const { data, handleDelete, handleViewClick, hideSeeResult } =
    props.capacityToSeeResult || {};
  const { origin: { city: originCity } = { city: "" }, destination: { city: destinationCity } = { city: "" } } = data;
  const isOriginDeadHead = originCity !== "" && originCity !== null && originCity !== Anywhere;
  const isDestinationDeadHead = destinationCity !== "" && destinationCity !== null && destinationCity !== Anywhere;
  const getLoadsList = () => {
    return (capacityLoadLoadPostings || []).map((load: any) => ({
      ...load,
      isWatched:
        (props.watchedLoads || []).find(
          (details: any) => details.loadId === load.loadId
        ) !== undefined,
    }));
  };

  useEffect(() => {
    setLoads(getLoadsList());

    // ContentStack option to use PCmiler Maps or Google Maps
    const _usePCmilerMaps = IONICWrapper.details.keys 
      && IONICWrapper.details.keys.configuration.usePCmilerMaps 
        || PCmiler.usePCmilerMaps;
    const isPCmilerMaps = _usePCmilerMaps === "true" ? true : false;
    setPCmilerMaps(isPCmilerMaps);

  }, [props.watchedLoads, capacityLoadLoadPostings]);

  const [shipmentToExpand, setShipmentToExpand] = useState<any>({});
  const onCloseMapView = (shipment: any) => {
    setShowMap(false);
    setShipmentToExpand((shipment && shipment.shipment) || {});
  };

  const onChangeRowIndex = (rowIndex: number) => {
    setTimeout(() => {
      const pointer = document.getElementsByClassName("load-map-grid")[0];
      pointer && pointer.scrollIntoView();
    }, 2000);
  };

  return (
    <IonPage className="manage-capacity-see-result-page">
      <ManageCapacityHeader
        title=""
        breadcrumbItems={[
          { name: "Manage Capacity", backUrl: "/app/manage-capacity" },
          {
            name: `${(data.capacityType || "Truck").toLowerCase()}-Results`,
            backUrl: "#",
          },
        ]}
      />
      <ManageCapacityCard
        data={data}
        handleDelete={handleDelete}
        handleViewClick={handleViewClick}
        hideSeeResult={true}
      />
      <div className="capacity-see-result">
        <IonRow className="see-result-header">
          <IonCol size="12">
            <div className="see-result-title">Results</div>
          </IonCol>
          <IonCol size="8" className="page-type-col">
            <ToggleButton
              handleChange={(value: string) => setShowMap(value === "map")}
              isMapActive={true}
            />
          </IonCol>
          <IonCol size="4" className="page-sort-col">
            <SortingOptions
              options={getSortOptions(isOriginDeadHead, isDestinationDeadHead)}
              sortedData={props.onSortedData}
            />
          </IonCol>
        </IonRow>

        <IonRow className="capacity-see-result-list">
          {!showMap ? (
            <IonCol className="12">
              <div className="total-load-count">
                {totalRecords || 0} Matches
              </div>
              <LoadsList
                loads={loads}
                module={props.module}
                history={props.history}
                toggleWatchLoad={props.toggleWatchLoad}
                isNetworkAvailable={props.isNetworkAvailable}
                userDetails={props.userDetails}
                buyLoadRequest={props.buyLoadRequest}
                bookLoadStatus={props.bookLoadStatus}
                getShipmentDetails={props.getShipmentDetails}
                buyLoadStatusRemove={props.buyLoadStatusRemove}
                buyLoadShipmentRequest={props.buyLoadShipmentRequest}
                fetchShipments={props.fetchShipments}
                carrierLoads={props.carrierLoads}
                removeSearchResults={props.removeSearchResults}
                removeRecommendedResults={props.removeRecommendedResults}
                removewatchedResults={props.removewatchedResults}
                handlerAfterBookLoad={()=>props.onSortedData && props.onSortedData()}
                isCarrierLoad={false}
                isManageCapacityResults={true}
                shipmentToExpand={shipmentToExpand}
                onChangeRowIndex={onChangeRowIndex}
                origin={originCity || Anywhere}
                destination={destinationCity || Anywhere}
              />
            </IonCol>
          ) : (
              <IonCol size="12">
                <div className="total-load-count">
                  {totalRecords || 0} Matches
                </div>
                {usePCmilerMaps ? (
                <ShipmentMap
                  shipments={capacityLoadLoadPostings}
                  onCloseMapView={onCloseMapView}
                />)  : (<GoogleShipmentMap
                  shipments={capacityLoadLoadPostings}
                  onCloseMapView={onCloseMapView}
                />)}
              </IonCol>
            )}
          <IonCol size="12">
            {capacityLoadLoadPostings.length === totalRecords ? (
              <p className="end_of_list">End of list</p>
            ) : (
              <ShowLoadCountBtn
                onShowMore={props.onShowMore}
                shouldShowLoadMoreUpdate={shouldShowLoadMoreUpdate}
                totalRecords={totalRecords}
                currentPage={currentPage}
                pageSize={pageSize}
              />
            )}
          </IonCol>
        </IonRow>
      </div>
    </IonPage>
  );
};
